export interface DateRange {
  dateFrom: string;
  dateTo: string;
}

export function toIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * The member reports open on the last twelve months. Local calendar dates,
 * not `toISOString()`: that is UTC and shifts the day near midnight.
 */
export function defaultDateRange(now: Date = new Date()): DateRange {
  const from = new Date(now);
  from.setFullYear(from.getFullYear() - 1);
  return { dateFrom: toIsoDate(from), dateTo: toIsoDate(now) };
}
